import React, { useEffect, useState } from "react";
import freshmentlogo from "../../../images/freshmentLogo1.png";
import moment from "moment";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import { toast } from "react-toastify";
import { Alert } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const DriveDetailPage = () => {
  const [copyMessagePhone, setCopyMessagePhone] = useState(false);
  const [copyMessageEmail, setCopyMessageEmail] = useState(false);
  const { id, user_id, college_id, token } = useParams();
  const [drive, setDrive] = useState(null);
  const [collegeName, setCollegeName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [interestedLoading, setInterestedLoading] = useState(false);
  const [notInterestedLoading, setNotInterestedLoading] = useState(false);
  const history = useHistory();

  const fetchDrive = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("campus_drive_id", id);
      formData.append("student_id", user_id);
      formData.append("college_connect_id", college_id);
      formData.append("edu_auth_job_details_token", token);
      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/PublicAPI/get_campus_drive_job_details_external`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      //   console.log(response.data);
      //   setDrive(response.data.data);
      if (response.data.success) {
        setDrive(response.data.data);
        setCollegeName(response.data?.college_name);
      } else {
        setError(response.data.message);
        setCollegeName(null);
        setDrive(null);
      }
    } catch (error) {
      setError(
        error?.response?.data?.message || "Failed to fetch drive details"
      );
      setCollegeName(null);
      setDrive(null);
    } finally {
      setLoading(false);
    }
  };
  // Job type options for display
  const jobTypeOptions = [
    { value: "full-time", label: "Full Time" },
    { value: "part-time", label: "Part Time" },
    { value: "contract", label: "Contract" },
    { value: "internship", label: "Internship" },
    { value: "remote", label: "Work From Home" },
  ];

  const handleInterested = async (isInterested) => {
    try {
      // Set the appropriate loading state based on the action
      if (isInterested) {
        setInterestedLoading(true);
      } else {
        setNotInterestedLoading(true);
      }

      const formData = new FormData();
      formData.append("campus_drive_id", id);
      formData.append("student_id", user_id);
      formData.append("college_connect_id", college_id);
      formData.append("like_job", isInterested ? "1" : "0");

      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/PublicAPI/interact_campus_drive_job`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Update state based on response if needed
      if (response.data.success) {
        toast.success(response.data.message || "Job interaction successful");
        if (isInterested) {
          setInterestedLoading(false);
        } else {
          setNotInterestedLoading(false);
        }
        setTimeout(() => {
          history.go(0);
        }, 1000);
      } else {
        toast.error(response.data.message || "Job interaction failed");
      }
    } catch (error) {
      console.log(error);
      // You could also add error handling here
    } finally {
      // Reset loading states
      setInterestedLoading(false);
      setNotInterestedLoading(false);
    }
  };

  const getSalaryLPA = (salary) => {
    if (!salary) return "Industry Standard";
    const num = Number(salary);
    if (isNaN(num)) return salary;
    const lpa = num / 100000;
    return `${lpa % 1 === 0 ? lpa.toFixed(0) : lpa.toFixed(1)}`;
  };
  // Copy function for contact info
  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === "phone") {
      setCopyMessagePhone(true);
      setTimeout(() => setCopyMessagePhone(false), 2000);
    } else {
      setCopyMessageEmail(true);
      setTimeout(() => setCopyMessageEmail(false), 2000);
    }
  };

  useEffect(() => {
    fetchDrive();
  }, []);

  // Loading Component
  if (loading) {
    return (
      <>
        <Header />
        <div className="loading-container">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center py-5">
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{ width: "3rem", height: "3rem" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <h4 className="mt-3">Loading Drive Details...</h4>
                <p className="text-muted">
                  Please wait while we fetch the information.
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <section>
      <Header />

      {!error ? (
        <div className="box">
          <div>
            <div className="col-12">
              <div className="p-3 mb-4 bg-white rounded-3 border-start border-primary border-4">
                <div className="d-flex align-items-center">
                  <div className="bg-primary text-white rounded-circle p-2 me-3">
                    <i className="fa fa-graduation-cap"></i>
                  </div>
                  <h4 className="fs-24 mb-0 text-primary college-title">
                    {collegeName || "College Name"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-start">
            {/* Left Column - Overview */}
            <div className="col-lg-4 col-md-12 mb-4">
              <div className="card h-100" style={{ height: "fit-content" }}>
                <div className="card-header border-0 pb-0">
                  <h4 className="fs-20 mb-0">Overview</h4>
                </div>
                <div className="card-body pt-4">
                  <div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Company Name:{" "}
                      </h5>
                      <span className="overview-value">
                        {drive.company_name || "N/A"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Job Type:
                      </h5>
                      <span className="overview-value">
                        {jobTypeOptions.find(
                          (option) => option.value === drive.job_type
                        )?.label || "N/A"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        {drive.job_type === "internship" ? "Stipend" : "Salary"}
                        :
                      </h5>
                      <span className="overview-value">
                        {drive?.job_type === "internship"
                          ? `${drive.salary} per month`
                          : `${getSalaryLPA(drive.salary)} LPA`}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Compensation Details:
                      </h5>
                      <span className="overview-value">
                        &nbsp;{drive.compensation_details || "N/A"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">Vacancy:</h5>
                      <span className="overview-value">
                        {drive.total_vacancy || "N/A"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Job Location:
                      </h5>
                      <span className="overview-value">
                        {drive.job_location || "Pan India"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Joining Date:
                      </h5>
                      <span className="overview-value">
                        {moment(drive.joining_date).isValid()
                          ? moment(drive.joining_date).format("DD-MM-YYYY")
                          : "TBD"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">
                        Passout Year:
                      </h5>
                      <span className="overview-value">
                        {drive.passout_year || "N/A"}
                      </span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <h5 className="mb-1 fs-14 custom-label me-1">HR Name:</h5>
                      <span className="overview-value">
                        {drive.hr_contact_person || "N/A"}
                      </span>
                    </div>
                    {/* Contact Number */}
                    {drive.hr_contact_number && (
                      <div className="mb-4 d-flex flex-wrap align-items-center contact-item">
                        <h5 className="mb-1 fs-14 custom-label me-1">
                          Contact No. :
                        </h5>
                        <span className="me-2">{drive.hr_contact_number}</span>
                        <div
                          className="copy-division2 fs-18 me-2 text-dark cursor-pointer"
                          onClick={() =>
                            handleCopy(drive.hr_contact_number, "phone")
                          }
                        >
                          <i className="fas fa-copy me-1 fs-18 icon-copy"></i>
                          {copyMessagePhone && (
                            <span
                              style={{ zIndex: 10 }}
                              className="copy-message fade-in-out"
                            >
                              Number copied!
                            </span>
                          )}
                        </div>
                        <a
                          href={`tel:${drive.hr_contact_number}`}
                          className="bg-primary rounded text-white"
                          style={{ padding: "8px 8px" }}
                        >
                          <i className="fas fa-phone-alt"></i>
                        </a>
                      </div>
                    )}
                    {/* Contact Email */}
                    {drive.hr_email && (
                      <div className="mb-3">
                        <h5 className="mb-2 fs-14 custom-label">
                          Contact Email:
                        </h5>
                        <div className="d-flex flex-wrap align-items-center">
                          <div className="text-break me-2 email-container">
                            {drive.hr_email}
                          </div>
                          <div>
                            <div
                              className="copy-division fs-18 text-dark cursor-pointer"
                              onClick={() =>
                                handleCopy(drive.hr_email, "email")
                              }
                            >
                              <i className="fas fa-copy fs-18 icon-copy"></i>
                              {copyMessageEmail && (
                                <span
                                  style={{ zIndex: 10 }}
                                  className="copy-message fade-in-out"
                                >
                                  Email copied!
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Job Details */}
            <div className="col-lg-8 col-md-12">
              <div className="card mb-4">
                <div className="card-header flex-column align-items-start">
                  <div className="d-block">
                    <h4
                      style={{ fontSize: 22 }}
                      className="d-block mb-3 job-title"
                    >
                      {drive.job_role_name ||
                        drive.other_job_role_name ||
                        "Campus Drive Job"}
                    </h4>
                    <div
                      className="d-flex flex-wrap job-info-container"
                      style={{ gap: "10px" }}
                    >
                      <span className="mb-2 me-2">
                        <div className="fs-14">
                          <i className="fas fa-briefcase me-2 text-warning"></i>
                          {drive.company_name}
                        </div>
                      </span>
                      <span className="mb-2 me-2">
                        <div className="fs-14">
                          <i className="fas fa-map-marker-alt me-2 text-warning"></i>
                          {drive.company_address || "Pan India"}
                        </div>
                      </span>
                      {/* <span className="mb-2 me-2">
                     <div className="fs-14">
                       <i className="fas fa-rupee-sign me-2 text-warning"></i>
                       {getSalaryLPA(drive.salary)}
                     </div>
                   </span> */}
                      {drive.course_name && (
                        <span className="mb-2 me-2">
                          <div className="fs-14">
                            <i className="fas fa-book me-2 text-warning"></i>
                            {drive.course_name}
                          </div>
                        </span>
                      )}
                      {drive.specialization_name && (
                        <span className="mb-2 me-2">
                          <div className="fs-14">
                            <i className="fas fa-user-graduate me-2 text-warning"></i>
                            {drive.specialization_name}
                          </div>
                        </span>
                      )}
                    </div>
                  </div>
                  {drive?.show_interaction_button && (
                    <div className="d-flex align-items-start flex-wrap gap-3 mt-3">
                      <button
                        className="bg-secondary text-white btn btn-sm"
                        onClick={() => handleInterested(true)}
                        disabled={interestedLoading || notInterestedLoading}
                      >
                        {interestedLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-check me-2"></i> Interested
                          </>
                        )}
                      </button>
                      <button
                        className={`btn-danger btn btn-sm`}
                        onClick={() => handleInterested(false)}
                        disabled={interestedLoading || notInterestedLoading}
                      >
                        {notInterestedLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-times me-2"></i> Not Interested
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>
                <div className="card-body">
                  <div className="row mb-3">
                    {drive.remark && (
                      <Alert variant="secondary" className="mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        {drive.remark}
                      </Alert>
                    )}
                    <div className="col-12">
                      <h4 className="fs-20 mb-3">Job Description</h4>
                      <div className="row">
                        <div
                          className="col-12 text-break"
                          dangerouslySetInnerHTML={{
                            __html: (drive.job_description || "N/A")
                              .replace(/\r\n/g, "<br />")
                              .replace(/\n/g, "<br />")
                              .replace(/\r/g, "<br />"),
                          }}
                        ></div>
                      </div>
                    </div>
                    {drive?.pre_placement_offer === "Yes" && (
                      <div className="col-12 mt-4">
                        <h4 className="fs-20 mb-3">PPO Eligibility Criteria</h4>
                        <div
                          className="text-break"
                          dangerouslySetInnerHTML={{
                            __html: (drive.ppo_eligibility_criteria || "N/A")
                              .replace(/\r\n/g, "<br />")
                              .replace(/\n/g, "<br />")
                              .replace(/\r/g, "<br />"),
                          }}
                        ></div>
                      </div>
                    )}
                    {drive.placement_eligibility_criteria && (
                      <div className="col-12 mt-4">
                        <h4 className="fs-20 mb-3">Eligibility Criteria</h4>
                        <div
                          className="text-break"
                          dangerouslySetInnerHTML={{
                            __html: (
                              drive.placement_eligibility_criteria || "N/A"
                            )
                              .replace(/\r\n/g, "<br />")
                              .replace(/\n/g, "<br />")
                              .replace(/\r/g, "<br />"),
                          }}
                        ></div>
                      </div>
                    )}
                    {drive.placement_interview_rounds && (
                      <div className="col-12 mt-4">
                        <h4 className="fs-20 mb-3">Interview Rounds</h4>
                        <div
                          className="text-break"
                          dangerouslySetInnerHTML={{
                            __html: (drive.placement_interview_rounds || "N/A")
                              .replace(/\r\n/g, "<br />")
                              .replace(/\n/g, "<br />")
                              .replace(/\r/g, "<br />"),
                          }}
                        ></div>
                      </div>
                    )}
                    {drive.placement_terms_and_conditions && (
                      <div className="col-12 mt-4">
                        <h4 className="fs-20 mb-3">Terms & Conditions</h4>
                        <div
                          className="text-break"
                          dangerouslySetInnerHTML={{
                            __html: (
                              drive.placement_terms_and_conditions || "N/A"
                            )
                              .replace(/\r\n/g, "<br />")
                              .replace(/\n/g, "<br />")
                              .replace(/\r/g, "<br />"),
                          }}
                        ></div>
                      </div>
                    )}
                    {/* Additional Documents */}
                    {(drive.job_description_file_url ||
                      drive.additional_document_file_url) && (
                        <div className="col-12 mt-4">
                          <h4 className="fs-20 mb-3">Documents</h4>
                          <div className="d-flex flex-wrap gap-3 document-container">
                            {drive.job_description_file_url && (
                              <a
                                download
                                href={drive.job_description_file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="document-file-link d-flex align-items-center px-3 py-2 border rounded shadow-sm text-decoration-none mb-2"
                              >
                                <i className="bi bi-file-earmark-text fs-3 me-2 text-primary"></i>
                                <span className="fw-semibold text-truncate">
                                  Job Description File
                                </span>
                              </a>
                            )}
                            {drive.additional_document_file_url && (
                              <a
                                download
                                href={drive.additional_document_file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="document-file-link d-flex align-items-center px-3 py-2 border rounded shadow-sm text-decoration-none mb-2"
                              >
                                <i className="bi bi-file-earmark-arrow-down fs-3 me-2 text-success"></i>
                                <span className="fw-semibold text-truncate">
                                  Additional Document
                                </span>
                              </a>
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                {/* <div className="card-footer">
                <div className="d-flex align-items-start flex-wrap gap-3">
                  {drive.hr_email && (
                    <button
                      className="bg-info text-white btn btn-sm"
                      onClick={handleInterested}
                    >
                      <i className="fas fa-check me-2"></i> Interested
                    </button>
                  )}
                  {drive.apply_online_url && (
                    <a
                      href={"#"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-warning"
                    >
                      <i className="fa fa-times me-2"></i> Not Interested
                    </a>
                  )}
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="authincation h-100 p-meddle">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center ">
              <div className="col-md-12">
                <div className="form-input-content text-center error-page">
                  <h1 className="error-text font-weight-bold">404</h1>
                  {/* <h4 className="d-flex align-items-center justify-content-center">
                  <i className="fa fa-exclamation-triangle text-warning me-2" />
                  <span></span>
                </h4> */}
                  <p>
                    <i className="fa fa-exclamation-triangle text-warning me-2" />
                    {error ||
                      "We couldn't find the drive details you're looking for. The drive may have been removed or the link might be invalid."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <style jsx>{`
        .popover-custom {
          border: none;
          border-radius: 10px;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
          background-color: #fff;
        }
        .icon-copy {
          color: #007bff;
        }
        .copy-div:hover {
          text-decoration: none;
          opacity: 0.8;
        }
        .copy-division {
          position: relative;
        }
        .copy-division2 {
          position: relative;
        }
        .copy-message {
          position: absolute;
          top: -30px;
          left: 10px;
          background-color: black;
          color: white;
          padding: 5px 8px;
          border-radius: 5px;
          font-size: 14px;
          white-space: nowrap;
          opacity: 0;
          transition: opacity 0.5s ease;
        }
        .copy-message.fade-in-out {
          opacity: 1;
        }
        .college-title {
          font-size: 22px;
        }
        .document-file-link {
          width: 100%;
          max-width: 300px;
          background: #f8f9fa;
          transition: box-shadow 0.2s;
        }
        .email-container {
          max-width: 80%;
          word-break: break-all;
        }

        @media (max-width: 767px) {
          .card-header,
          .card-body {
            padding: 15px;
          }
          .copy-message {
            left: -15px;
          }
        }
      `}</style>
    </section>
  );
};

export default DriveDetailPage;

function Header() {
  return (
    <header className="bg-white py-3 mb-4">
      <div className="box">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="header-left mb-0 text-start">
            <div
              className="dashboard_bar"
              style={{
                textTransform: "capitalize",
                fontSize: "1.25rem",
                fontWeight: "600",
                display: "block",
              }}
            >
              Campus Drive Details
            </div>
          </div>
          <div className="brand-logo">
            <img
              src={freshmentlogo}
              alt="logo"
              className="img-fluid logo-img"
            />
          </div>
        </div>
      </div>
      <style jsx>{`
        .logo-img {
          max-width: 100%;
          height: auto;
          width: 200px;
        }
        @media only screen and (max-width: 767px) {
          .logo-img {
            width: 150px;
          }
        }
      `}</style>
    </header>
  );
}
